module.exports = __webpack_public_path__ + "img/Vencasa-Leaf-Top-Border-4K.32ef1d66.webp";